import Teams from "components/Teams/Teams";
import CreateNewMember from "components/Teams/createNewMember/CreateNewMember";
import React from "react";

const CreateNewMemberPage = () => {
  return <CreateNewMember />;
};

export default CreateNewMemberPage;
